'use es6';

export const convertToAbsolute = path => {
  if (typeof path !== 'string') {
    return path;
  }

  if (path[0] === '/' || path[0] === '.') {
    return path;
  }

  return `/${path}`;
}; // If given path is relative, return its absolute path based on given absolute file path
// If given path is absolute, return as is

export function getAbsolutePath(path, absolutePath) {
  if (typeof absolutePath !== 'string' || typeof path !== 'string') {
    return path;
  }

  const directoryPath = absolutePath.split('/').slice(0, -1).join('/');

  if (path.startsWith('./')) {
    return `${directoryPath}/${path.slice(2)}`;
  }

  if (path.startsWith('../')) {
    const nextPath = path.slice(3).startsWith('../') ? path.slice(3) // pass in next ../ path
    : path.slice(1); // pass in ./ path to prepend directory path

    return getAbsolutePath(nextPath, directoryPath);
  }

  return path.startsWith('/') ? path : `/${path}`;
}
export const formatPathSlug = path => {
  path = path[0] === '/' ? path.slice(1) : path;
  return encodeURIComponent(path);
};

function trimArray(arr) {
  const lastIndex = arr.length - 1;
  let start = 0;

  for (; start <= lastIndex; start++) {
    if (arr[start]) break;
  }

  let end = lastIndex;

  for (; end >= 0; end--) {
    if (arr[end]) break;
  }

  if (start === 0 && end === lastIndex) return arr;
  if (start > end) return [];
  return arr.slice(start, end + 1);
} // get relative path from two absolute paths


export function relative(from, to) {
  from = from.substr(1);
  to = to.substr(1);
  const fromParts = trimArray(from.split('/'));
  const toParts = trimArray(to.split('/'));
  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;

  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];

  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));
  return outputParts.join('/');
}